module.exports = __webpack_public_path__ + "media/images/static/top/local/photo1_mobile-a499f89f425c89b9a740c3031330cd45.png";